import * as R from 'ramda'

export function validate_composite() {
    this.$v.$touch()

    if (this.$v.$invalid) {
        return Promise.reject()
    }

    return Promise.resolve()
}

function _handle_multiple_validations(onError, results) {
    return R.compose(

        // Bei Fehler `onError`-Callback ausfuehren
        result => {
            if (R.equals(false, result)) {
                onError()
            }

            return result
        },

        // Pruefen ob alle Validierungen erfolgreich waren
        R.all(R.equals(true))

    )(results)
}
export const handle_multiple_validations = R.curry(_handle_multiple_validations)
